import React from 'react'
import type { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import type { Company } from '@homeviews/models'
import { Typography, StarRating } from '@homeviews/shared-ui'
import { maybePlaceholderImage } from '@homeviews/utils'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: 20,
      border: '0.5px solid rgba(0,0,0,0.02)',
      borderRadius: 5,
      backgroundColor: theme.colors.white,
      boxShadow: '0 15px 20px 0 rgba(46,81,123,0.04)',
      overflow: 'hidden',
      marginTop: 20,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      textDecoration: 'none !important',
    },
    imageWrapper: {
      position: 'relative',
      overflow: 'hidden',
      height: 109,
      width: 185,
      border: '1px solid #E3E3E3',
      marginRight: 30,
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: 10,
      },
    },
    body: {
      flex: 1,
      paddingTop: theme.spacing(1.375),
    },
    title: {
      fontSize: 20,
    },
    meta: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 10,
    },
    metaEl: {
      color: theme.colors.grey450,
      marginRight: theme.spacing(0.9375),
      marginTop: theme.spacing(0.625),
      marginBottom: theme.spacing(0.625),
    },
    metaElNoMargin: {
      marginTop: 0,
    },
    starRatingWrapper: {
      marginTop: 2,
    },
    metaElItemWrapper: {
      fontSize: 14,
      '& span': {
        color: '#434343',
        fontWeight: 500,
        fontSize: 16,
      },
    },
    bodyHeader: {},
    description: {
      color: theme.colors.grey650,
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxHeight: 40,
    },
    devCount: {
      color: `#00837D !important`,
      fontSize: `16px!important`,
    },
    ratingWrapper: {
      marginRight: 30,
    },
  }),
)
interface IProps extends Company {
  className?: string
}

const CompanyCard: FC<IProps> = ({
  className,
  name,
  rating,
  no_of_reviews,
  no_of_developments,
  description,
  logo,
}) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.imageWrapper}>
        <img src={maybePlaceholderImage(logo)} alt={`${name}`} />
      </div>
      <div className={classes.body}>
        <div className={classes.bodyHeader}>
          <Typography variant="h3" className={classes.title}>
            {name}
          </Typography>
        </div>

        <div className={classes.meta}>
          <div className={clsx(classes.metaEl)}>
            <StarRating value={parseFloat(rating)} fontSize={24} />
          </div>
          <div className={clsx(classes.meta, classes.ratingWrapper)}>
            <Typography
              className={clsx(classes.metaEl, classes.metaElItemWrapper)}
            >
              <span style={{ marginLeft: '8px' }}>{rating} </span>{' '}
              {no_of_reviews &&
                `(${no_of_reviews} ${
                  no_of_reviews === 1 ? 'review' : 'reviews'
                })`}
            </Typography>
          </div>
          <div className={classes.meta}>
            <Typography
              className={clsx(classes.metaEl, classes.metaElItemWrapper)}
            >
              <span>Number of Developments </span>
              {'  '}
              <span className={classes.devCount}>
                {no_of_developments || 0}
              </span>
            </Typography>
          </div>
        </div>
        {!!description && (
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
            className={classes.description}
          />
        )}
      </div>
    </div>
  )
}

export default CompanyCard
